import { internalNetworkClient } from '@terra/shared-rest-clients-internal-network';
import type {
  AdEntityListGroupByField,
  AdEntityListOrderByDto,
  InternalNetworkAdEntityKind,
  InternalNetworkContract,
} from '@terra/shared-contracts-internal-network';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const internalNetworkAdEntitiesApi = {
  listInternalNetworkAdEntities: ({
    networkId,
    entityKind,
    skip,
    limit,
    orderBy,
    groupBy,
  }: {
    networkId: string;
    entityKind?: InternalNetworkAdEntityKind;
    skip?: number;
    limit?: number;
    orderBy?: AdEntityListOrderByDto[];
    groupBy?: AdEntityListGroupByField;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.listAdEntities>({
      endpointFn: (headers) =>
        internalNetworkClient.listAdEntities({
          params: { networkId },
          query: { entityKind, skip, limit, orderBy, groupBy },
          ...withOrchestratorClient(headers),
        }),
    }),

  listAllInternalNetworkAdEntities: ({
    networkId,
    limit,
  }: {
    networkId: string;
    limit?: number;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.listAllAdEntities>({
      endpointFn: (headers) =>
        internalNetworkClient.listAllAdEntities({
          params: { networkId },
          query: { limit },
          ...withOrchestratorClient(headers),
        }),
    }),

  searchInternalNetworkAdEntities: ({
    networkId,
    term,
    entityKind,
    skip,
    limit,
    orderBy,
    groupBy,
  }: {
    networkId: string;
    term: string;
    entityKind?: InternalNetworkAdEntityKind;
    skip?: number;
    limit?: number;
    orderBy?: AdEntityListOrderByDto[];
    groupBy?: AdEntityListGroupByField;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.searchAdEntities>({
      endpointFn: (headers) =>
        internalNetworkClient.searchAdEntities({
          params: { networkId },
          query: { q: term, entityKind, skip, limit, orderBy, groupBy },
          ...withOrchestratorClient(headers),
        }),
    }),

  getInternalNetworkAdEntity: ({
    networkId,
    nodeId,
  }: {
    networkId: string;
    nodeId: string;
  }) =>
    tenantAwareApiWrapper<typeof InternalNetworkContract.getAdEntity>({
      endpointFn: (headers) =>
        internalNetworkClient.getAdEntity({
          params: { networkId, nodeId },
          ...withOrchestratorClient(headers),
        }),
    }),

  getInternalNetworkAdEntityRelationships: ({
    networkId,
    nodeId,
    limit,
  }: {
    networkId: string;
    nodeId: string;
    limit?: number;
  }) =>
    tenantAwareApiWrapper<
      typeof InternalNetworkContract.getAdEntityRelationships
    >({
      endpointFn: (headers) =>
        internalNetworkClient.getAdEntityRelationships({
          params: { networkId, nodeId },
          query: { limit, direction: 'both' },
          ...withOrchestratorClient(headers),
        }),
    }),
};
